import React from 'react'
import { Defs, LinearGradient, Path, Stop } from 'react-native-svg'
import { useTheme } from 'styled-components'
import styled from 'styled-components/native'

import { AccessibleSvg } from 'ui/svg/AccessibleSvg'
import { AccessibleIcon } from 'ui/svg/icons/types'
import { svgIdentifier } from 'ui/svg/utils'

const BicolorRingingBellSvg: React.FunctionComponent<AccessibleIcon> = ({
  size,
  color,
  color2,
  accessibilityLabel,
  testID,
}) => {
  const height = typeof size === 'string' ? size : ((size as number) * 156) / 200
  const {
    colors: { primary, secondary },
  } = useTheme()
  const { id: gradientId, fill: gradientFill } = svgIdentifier()

  return (
    <AccessibleSvg
      width={size}
      height={height}
      viewBox="0 0 200 156"
      accessibilityLabel={accessibilityLabel}
      testID={testID}>
      <Defs>
        <LinearGradient
          id={gradientId}
          x1="28.841%"
          x2="71.159%"
          y1="0%"
          y2="100%"
          gradientUnits="userSpaceOnUse">
          <Stop offset="0%" stopColor={color ?? primary} />
          <Stop offset="100%" stopColor={color2 ?? secondary} />
        </LinearGradient>
      </Defs>
      <Path
        d="M132.972 17.6475C143.116 17.657 151.331 25.8879 151.322 36.0317C151.32 37.4124 152.439 38.5327 153.819 38.534C155.2 38.5353 156.32 37.4171 156.322 36.0364C156.334 23.1312 145.882 12.6596 132.977 12.6475C131.596 12.6462 130.476 13.7644 130.474 15.1451C130.473 16.5258 131.591 17.6462 132.972 17.6475Z"
        fill={gradientFill}
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M86.3963 33.2699C85.429 28.1238 89.6084 23.7628 94.6077 22.8231C99.607 21.8833 105.085 24.429 106.052 29.575L106.521 32.0674C112.295 32.5015 117.759 34.2898 122.484 37.3669C129.912 42.2051 135.354 50.1288 137.319 60.5826L141.937 85.1522C142.449 87.8739 145.053 89.6541 147.775 89.1425C153.21 88.1207 158.428 91.6874 159.45 97.1229C160.472 102.558 156.905 107.776 151.47 108.798L107.151 117.129C107.461 117.887 107.704 118.693 107.863 119.543C109.139 126.33 104.675 132.862 97.8878 134.137C91.101 135.413 84.5695 130.949 83.2937 124.162C83.1354 123.319 83.0648 122.48 83.0776 121.654L72.8466 123.578C67.4111 124.599 62.1931 121.033 61.1714 115.597C60.1496 110.162 63.7163 104.944 69.1518 103.922C71.8734 103.41 73.6536 100.806 73.142 98.0841L68.5235 73.5144C67.822 69.7828 67.6565 66.1704 67.9703 62.7471C68.0963 61.3721 69.3131 60.3597 70.6881 60.4858C72.063 60.6118 73.0754 61.8286 72.9494 63.2035C72.6795 66.1477 72.818 69.2955 73.4375 72.5907L78.056 97.1604C78.3927 98.9516 78.2311 100.719 77.6686 102.321L106.006 96.994C107.363 96.7389 108.67 97.6321 108.925 98.9891C109.18 100.346 108.287 101.653 106.93 101.908L70.0755 108.836C67.3539 109.347 65.5737 111.952 66.0853 114.673C66.5969 117.395 69.2013 119.175 71.9229 118.664L150.546 103.884C153.268 103.373 155.048 100.768 154.536 98.0466C154.025 95.325 151.42 93.5448 148.699 94.0564L131.5 97.2894C130.143 97.5445 128.836 96.6512 128.581 95.2943C128.326 93.9373 129.219 92.6305 130.576 92.3754L139.258 90.7434C138.152 89.4554 137.36 87.8672 137.023 86.076L132.405 61.5063C130.675 52.3042 125.965 45.6016 119.755 41.5565C113.525 37.4986 105.628 36.0143 97.3788 37.5649C90.6227 38.8349 84.8061 41.9255 80.5484 46.3167C79.5873 47.308 78.0045 47.3324 77.0133 46.3713C76.022 45.4101 75.9976 43.8274 76.9587 42.8361C79.7663 39.9405 83.1161 37.5555 86.8647 35.7616L86.3963 33.2699ZM88.1596 120.699C88.1557 120.758 88.1498 120.816 88.1417 120.875C88.0391 121.625 88.0537 122.419 88.2077 123.238C88.9733 127.311 92.8912 129.989 96.9641 129.223C101.037 128.458 103.715 124.54 102.949 120.467C102.787 119.604 102.482 118.811 102.064 118.085L88.1596 120.699ZM101.138 30.4988L101.427 32.0331C99.7807 32.1324 98.1205 32.3379 96.4551 32.6509C94.7906 32.9638 93.169 33.3753 91.5987 33.8806L91.3103 32.3462C91.0029 30.711 92.3736 28.3306 95.5314 27.737C98.6892 27.1434 100.831 28.8636 101.138 30.4988Z"
        fill={gradientFill}
      />
      <Path
        d="M138.341 38.9665C138.345 34.3437 134.601 30.5927 129.979 30.5884C128.598 30.5871 127.48 29.4667 127.481 28.086C127.482 26.7053 128.603 25.5871 129.983 25.5884C137.367 25.5953 143.348 31.587 143.341 38.9712C143.34 40.3519 142.219 41.4701 140.839 41.4688C139.458 41.4675 138.34 40.3472 138.341 38.9665Z"
        fill={gradientFill}
      />
      <Path
        d="M56.392 121.515C56.1136 124.675 58.4491 127.462 61.6086 127.74C62.9839 127.861 64.0007 129.074 63.8795 130.45C63.7583 131.825 62.5451 132.842 61.1697 132.721C55.2595 132.2 50.8905 126.987 51.4113 121.076C51.5325 119.701 52.7457 118.684 54.1211 118.805C55.4964 118.927 56.5132 120.14 56.392 121.515Z"
        fill={gradientFill}
      />
      <Path
        d="M58.4042 138.362C50.5474 137.67 44.7394 130.739 45.4316 122.883C45.5528 121.507 44.5361 120.294 43.1607 120.173C41.7853 120.052 40.5721 121.068 40.4509 122.444C39.5163 133.051 47.3577 142.408 57.9653 143.343C59.3407 143.464 60.5539 142.447 60.6751 141.072C60.7963 139.697 59.7796 138.483 58.4042 138.362Z"
        fill={gradientFill}
      />
    </AccessibleSvg>
  )
}

export const BicolorRingingBell = styled(BicolorRingingBellSvg).attrs(({ size, theme }) => ({
  size: size ?? theme.illustrations.sizes.medium,
}))``
